import { get } from 'lodash'

import { useActions } from '../../core/globalState/hooks'
import type { OrderForm } from '../../core/requests/checkout'

function sendLogisticsInfoOnShippingData(
  logisticsInfo: LogisticsInfo,
  orderForm: OrderForm | undefined,
  itemId?: string
) {
  const shippingData = get(orderForm, 'shippingData')

  return sendShippingData({
    shippingData: {
      ...shippingData,
      logisticsInfo,
    },
    errorTitle: 'shippingErrorSendingData',
    itemId,
  })
}

function sendShippingData({
  previousShippingAddress,
  retryAction,
  shippingData,
  errorTitle,
  itemId,
  shouldRefreshSimulation,
}: any) {
  return {
    type: 'instore/shipping/SEND_SHIPPING_DATA',
    payload: {
      previousShippingAddress,
      retryAction,
      shippingData,
      errorTitle,
      itemId,
      shouldRefreshSimulation,
    },
  }
}

const refreshPickupPoints = () => ({
  type: 'instore/shipping/REFRESH_PICKUP_POINTS',
  payload: {},
})

function sendNewScheduledDeliveryChoice({
  items,
  deliveryWindow,
  selectedSla,
}: any) {
  return {
    type: 'instore/shipping/SEND_SCHEDULED_DELIVERY',
    payload: {
      items,
      scheduledDeliveryChoice: { deliveryWindow, selectedSla },
    },
  }
}

export const useShippingActionsLegacy = () => {
  const actions = useActions(
    {
      sendLogisticsInfoOnShippingData,
      refreshPickupPoints,
      sendNewScheduledDeliveryChoice,
    },
    []
  )

  return actions
}
